import { FieldValidation } from '@atlassian/mpac-utils';
export const checkSlaUrl = name => url => {
  if (!FieldValidation.checkNonEmptyString(name)(url)) {
    return FieldValidation.checkValidHttpUrl(name)(url);
  }
};